'use strict';

module.exports = Point;

function Point(x, y) {
  this.x = x;
  this.y = y;
}

Point.prototype = {
  clone: function clone() {
    return new Point(this.x, this.y);
  },
  add: function add(p) {
    return this.clone()._add(p);
  },
  sub: function sub(p) {
    return this.clone()._sub(p);
  },
  mult: function mult(k) {
    return this.clone()._mult(k);
  },
  div: function div(k) {
    return this.clone()._div(k);
  },
  rotate: function rotate(a) {
    return this.clone()._rotate(a);
  },
  matMult: function matMult(m) {
    return this.clone()._matMult(m);
  },
  unit: function unit() {
    return this.clone()._unit();
  },
  perp: function perp() {
    return this.clone()._perp();
  },
  round: function round() {
    return this.clone()._round();
  },
  mag: function mag() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  },
  equals: function equals(p) {
    return this.x === p.x && this.y === p.y;
  },
  dist: function dist(p) {
    return Math.sqrt(this.distSqr(p));
  },
  distSqr: function distSqr(p) {
    var dx = p.x - this.x,
        dy = p.y - this.y;
    return dx * dx + dy * dy;
  },
  angle: function angle() {
    return Math.atan2(this.y, this.x);
  },
  angleTo: function angleTo(b) {
    return Math.atan2(this.y - b.y, this.x - b.x);
  },
  angleWith: function angleWith(b) {
    return this.angleWithSep(b.x, b.y);
  },
  // Find the angle of the two vectors, solving the formula for the cross product a x b = |a||b|sin(θ) for θ.
  angleWithSep: function angleWithSep(x, y) {
    return Math.atan2(this.x * y - this.y * x, this.x * x + this.y * y);
  },
  _matMult: function _matMult(m) {
    var x = m[0] * this.x + m[1] * this.y,
        y = m[2] * this.x + m[3] * this.y;
    this.x = x;
    this.y = y;
    return this;
  },
  _add: function _add(p) {
    this.x += p.x;
    this.y += p.y;
    return this;
  },
  _sub: function _sub(p) {
    this.x -= p.x;
    this.y -= p.y;
    return this;
  },
  _mult: function _mult(k) {
    this.x *= k;
    this.y *= k;
    return this;
  },
  _div: function _div(k) {
    this.x /= k;
    this.y /= k;
    return this;
  },
  _unit: function _unit() {
    this._div(this.mag());

    return this;
  },
  _perp: function _perp() {
    var y = this.y;
    this.y = this.x;
    this.x = -y;
    return this;
  },
  _rotate: function _rotate(angle) {
    var cos = Math.cos(angle),
        sin = Math.sin(angle),
        x = cos * this.x - sin * this.y,
        y = sin * this.x + cos * this.y;
    this.x = x;
    this.y = y;
    return this;
  },
  _round: function _round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
}; // constructs Point from an array if necessary

Point.convert = function (a) {
  if (a instanceof Point) {
    return a;
  }

  if (Array.isArray(a)) {
    return new Point(a[0], a[1]);
  }

  return a;
};